module.exports = __webpack_public_path__ + "static/media/the-game-afl-2024.bd3c2128.png";